import styled, { css } from 'styled-components'
import { colorToLunaToken } from '../../../../helpers/theming/utilities'
import { NectarHeading } from '../../../../helpers/StyledWrappers.styles'
import { M0012StyledContainer, M0012StyledCountdown, M0012StyledSponsorText, M0012StyledSponsorLogo } from './types'

const spacing = (props) => props.theme.size.spacing.lg

const StyledContainer = styled.a<M0012StyledContainer>`
  height: 250px;
  width: 100%;
  padding: 0 ${(props) => spacing(props)};
  border-radius: ${(props) => props.theme.size.border.radius.base};
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  ${(props) =>
    css`
      margin-bottom: ${spacing(props)};
      color: ${colorToLunaToken(props.textColor, props.theme)};
      background-color: ${colorToLunaToken(props.backgroundColor, props.theme)};
    `}

  ${(props) =>
    props.theme.channel === 'habitat' && props.height !== 'small'
      ? css`
          @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
            height: 350px;
          }
          @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
            height: 420px;
          }
        `
      : css`
          @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
            height: 350px;
            ${props.height === 'small' &&
            css`
              height: auto;
              min-height: 100px;
              padding: ${spacing(props)}; ;
            `}
          }
        `}

  ${(props) =>
    props.height === 'small' &&
    css`
      height: auto;
      min-height: 100px;
      padding: ${spacing(props)}; ;
    `}
  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`

const StyledContentWrapper = styled.div<M0012StyledContainer>`
  max-width: 320px;
  text-align: center;
  z-index: 2;
  color: ${(props) => colorToLunaToken(props.textColor, props.theme)};
  h1 {
    margin: 0;
    ${NectarHeading}
  }
  h4 {
    margin-bottom: 0;
    margin-top: ${(props) => spacing(props)};
  }

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    max-width: 550px;
  }
`

const StyledClock = styled.div`
  color: ${(props) => props.theme.color.monochrome.white};
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
  margin-top: 10px;
  height: 68px;
`

const StyledCountdown = styled.div<M0012StyledCountdown>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  transition: opacity 0.25s ease-in;
  ${(props) =>
    props.expiredOrActive === 'expired'
      ? css`
          opacity: 0;
        `
      : css`
          opacity: 1;
        `}
`

const StyledGroup = styled.div`
  margin: 0 5px;
  width: 44px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.25);
  padding: 5px;
  border-radius: ${(props) => props.theme.size.border.radius.base};
  position: relative;
  overflow: hidden;
  &::before {
    left: -10px;
    top: -22px;
    content: '';
    display: block;
    transform: rotate(12deg);
    position: absolute;
    z-index: 0;
    width: 150%;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.25);
  }
`

const StyledCountdownTime = styled.h4`
  display: block;
  position: relative;
  margin: 0;
`

const StyledCountdownLabel = styled.small`
  margin-bottom: -4px !important;
`

const StyledSponsorText = styled.p<M0012StyledSponsorText>`
  margin: 10px 0 5px;
  color: ${(props) => colorToLunaToken(props.textColor, props.theme)};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    margin: ${(props) => spacing(props)} 0 ${(props) => props.theme.size.spacing.md};
  }
`

const StyledSponsorLogo = styled.div<M0012StyledSponsorLogo>`
  height: 20px;
  width: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`

const StyledCTAContainer = styled.div`
  margin: ${(props) => props.theme.size.spacing.md} 0 ${(props) => props.theme.size.spacing.sm};

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    margin: ${(props) => spacing(props)} 0 ${(props) => props.theme.size.spacing.md};
  }
`

const StyledCTA = styled.span`
  font-weight: ${(props) => props.theme.font.weight.bold};
  text-decoration: underline;
`

export {
  StyledContainer,
  StyledContentWrapper,
  StyledClock,
  StyledCountdown,
  StyledGroup,
  StyledCountdownTime,
  StyledCountdownLabel,
  StyledSponsorText,
  StyledSponsorLogo,
  StyledCTAContainer,
  StyledCTA
}
